import './Loading.css';

function Loading() {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-primary-light to-secondary-light flex items-center justify-center">
      <div className="text-center">
        <svg
          className="startup-trace-loader mx-auto mb-4"
          viewBox="0 0 50 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          role="img"
          aria-label="Загрузка"
        >
          <defs>
            <radialGradient
              id="startup-loader-gradient"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(36.9704 14.0332) scale(47.286 46.7686)"
            >
              <stop stopColor="#FFF6B8" />
              <stop offset=".18" stopColor="#FFEA7A" />
              <stop offset=".35" stopColor="#FFDC38" />
              <stop offset=".53" stopColor="#FFCC00" />
              <stop offset=".7" stopColor="#F8BC00" />
              <stop offset=".86" stopColor="#EFAE00" />
              <stop offset="1" stopColor="#EAA600" />
            </radialGradient>
            <clipPath id="startup-loader-clip">
              <path d="M30.3216 12.3433C27.1014 12.3433 24.2911 14.5021 23.4964 17.5874L19.6532 32.4838C19.3967 33.4805 17.9103 33.297 17.9103 32.2686V21.2005C17.9103 16.3075 13.9 12.3433 8.95516 12.3433C4.01035 12.3433 0 16.3121 0 21.2028V39.2343H6.09225V21.4587C6.09225 19.8934 7.37483 18.6272 8.95516 18.6272C10.5355 18.6272 11.8181 19.8957 11.8181 21.4587V33.331C11.8181 37.0143 14.8367 39.9977 18.5585 39.9977C21.6435 39.9977 24.337 37.9249 25.0928 34.9665L28.842 20.3193C29.2291 18.8061 31.4026 18.8061 31.7897 20.3193L36.6314 39.232H42.7236L37.1421 17.5851C36.3474 14.4999 33.5372 12.3411 30.317 12.3411L30.3216 12.3433Z" />
            </clipPath>
          </defs>

          <path
            className="startup-trace-loader__ghost"
            fill="url(#startup-loader-gradient)"
            d="M30.3216 12.3433C27.1014 12.3433 24.2911 14.5021 23.4964 17.5874L19.6532 32.4838C19.3967 33.4805 17.9103 33.297 17.9103 32.2686V21.2005C17.9103 16.3075 13.9 12.3433 8.95516 12.3433C4.01035 12.3433 0 16.3121 0 21.2028V39.2343H6.09225V21.4587C6.09225 19.8934 7.37483 18.6272 8.95516 18.6272C10.5355 18.6272 11.8181 19.8957 11.8181 21.4587V33.331C11.8181 37.0143 14.8367 39.9977 18.5585 39.9977C21.6435 39.9977 24.337 37.9249 25.0928 34.9665L28.842 20.3193C29.2291 18.8061 31.4026 18.8061 31.7897 20.3193L36.6314 39.232H42.7236L37.1421 17.5851C36.3474 14.4999 33.5372 12.3411 30.317 12.3411L30.3216 12.3433Z"
          />

          <g clipPath="url(#startup-loader-clip)">
            <path
              className="startup-trace-loader__line"
              fill="none"
              stroke="url(#startup-loader-gradient)"
              strokeWidth="8"
              strokeLinecap="round"
              strokeLinejoin="round"
              pathLength="1"
              d="M3.05 42V21.3A5.907 5.907 0 0 1 14.864 21.3V32.2C14.864 37.3 21.5 38.7 22.6 33.5L26.3 19.2C27.1 14.9 33.6 14.85 34.6 19.3L40.35 42"
            />
          </g>

          <path
            className="startup-trace-loader__star"
            fill="#FFF6B8"
            d="M49.9994 7.19447C48.1992 6.7754 46.5914 5.86929 45.3271 4.61887C44.0629 3.36844 43.1468 1.77823 42.723 0H42.1963C41.7726 1.77823 40.8564 3.37071 39.5922 4.61887C38.3279 5.86929 36.7201 6.7754 34.9199 7.19447V7.71322C36.7201 8.13229 38.3279 9.0384 39.5922 10.2888C40.8564 11.5392 41.7726 13.1317 42.1963 14.9122H42.7208C43.1445 13.1317 44.0606 11.5392 45.3248 10.2888C46.5891 9.0384 48.1969 8.13229 49.9971 7.71322V7.19447H49.9994Z"
          />
        </svg>
      </div>
    </div>
  );
}

export default Loading;
